/* ===========================================================================
 * ZEPHIR - Ventana de informacion sin salir de la ficha.
 *
 * "Politica de envios" y "Cambios y devoluciones" sacaban al cliente de la PDP.
 * Aqui se interceptan, se trae el contenido de la pagina por fetch y se muestra
 * en una ventana propia.
 *
 * Archivo aparte del resto de la ficha para poder ajustar la ventana sin
 * reescribir los comportamientos, y al reves. Se carga desde
 * sections/zephir-fonts.liquid, junto con los otros assets propios.
 *
 * QUE ENLACES SE INTERCEPTAN. No hay lista de handles: se intenta con cualquier
 * /pages/... que este dentro de la columna de informacion y se decide POR EL
 * CONTENIDO. Si de la respuesta sale un .t4s-rte se abre la ventana; si no, se
 * navega a la pagina como siempre. Comprobado: politica-de-envios y
 * politica-de-cambios-y-devoluciones traen .t4s-rte (1.901 y 2.351 caracteres),
 * pero /pages/tiendas NO -- esta armada con secciones propias y en una ventana
 * saldria vacia. Asi la regla se autolimita sola: si una pagina de texto cambia
 * de nombre sigue funcionando, y si una pagina no es de texto se abre entera.
 *
 * SE BUSCA PRIMERO Y SE ABRE DESPUES: abrir con "Cargando" y tener que cerrar
 * para navegar (el caso de tiendas) se ve como un parpadeo. Si el fetch pasa de
 * 200 ms se atenua el enlace para dar senal de vida.
 *
 * EL TITULO SALE DEL CONTENIDO, no del texto del enlace: estas paginas traen su
 * encabezado dentro del .t4s-rte, y la de cambios lo trae DOS VECES seguidas.
 * Se toma el primero como titulo, se quita del cuerpo, y se quita el siguiente
 * si repite el mismo texto.
 * =========================================================================== */
(function () {
  'use strict';

  var CURVA = 'cubic-bezier(.16,1,.3,1)';
  var CACHE = {};
  var caja = null, foco = null, cerrando = null;

  var css = document.createElement('style');
  css.textContent =
    '.zph-mo{position:fixed;inset:0;z-index:9999;display:flex;opacity:0;' +
      'transition:opacity .28s ' + CURVA + ';}' +
    '.zph-mo.is-on{opacity:1;}' +
    '.zph-mo__fondo{position:absolute;inset:0;background:rgba(22,22,22,.42);' +
      '-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);}' +
    '.zph-mo__caja{position:relative;background:#fff;display:flex;flex-direction:column;' +
      'box-shadow:0 24px 60px rgba(0,0,0,.18);}' +
    '.zph-mo__cab{display:flex;align-items:flex-start;justify-content:space-between;gap:20px;' +
      'padding:26px 28px 18px;border-bottom:1px solid var(--zephir-line,#e7e3df);flex:0 0 auto;}' +
    '.zph-mo__t{margin:0;font-family:var(--font-family-2);font-weight:400;' +
      'font-size:23px;line-height:1.2;letter-spacing:.2px;color:#161616;}' +
    '.zph-mo__x{flex:0 0 auto;width:32px;height:32px;margin:-4px -6px 0 0;padding:0;border:0;' +
      'background:none;cursor:pointer;color:#161616;display:flex;align-items:center;' +
      'justify-content:center;opacity:.55;transition:opacity .2s;}' +
    '.zph-mo__x:hover{opacity:1;}' +
    '.zph-mo__x svg{width:14px;height:14px;}' +
    /* Solo el cuerpo desplaza: el titulo queda siempre a la vista. */
    '.zph-mo__cuerpo{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:22px 28px 30px;' +
      'font-size:13.5px;line-height:1.85;color:#3f3f3f;overscroll-behavior:contain;}' +
    '.zph-mo__cuerpo > *:first-child{margin-top:0;}' +
    '.zph-mo__cuerpo > *:last-child{margin-bottom:0;}' +
    '.zph-mo__cuerpo p{margin:0 0 14px;}' +
    '.zph-mo__cuerpo h2,.zph-mo__cuerpo h3,.zph-mo__cuerpo h4{font-family:var(--font-family-2);' +
      'font-weight:400;font-size:16px;line-height:1.3;color:#161616;margin:26px 0 10px;}' +
    '.zph-mo__cuerpo ul,.zph-mo__cuerpo ol{margin:0 0 14px;padding-left:20px;}' +
    '.zph-mo__cuerpo li{margin:0 0 6px;}' +
    '.zph-mo__cuerpo strong,.zph-mo__cuerpo b{font-weight:600;color:#161616;}' +
    '.zph-mo__cuerpo a{color:#161616;text-decoration:underline;text-underline-offset:2px;}' +
    '.zph-mo__cuerpo img{max-width:100%;height:auto;}' +
    '.zph-mo__cuerpo table{width:100%;border-collapse:collapse;margin:0 0 14px;}' +
    '.zph-mo__cuerpo td,.zph-mo__cuerpo th{border:1px solid var(--zephir-line,#e7e3df);' +
      'padding:8px 10px;text-align:left;}' +
    '.zph-cargando{opacity:.45;cursor:progress;}' +
    /* BLOQUEO DEL FONDO CON CLASE Y !important, no con style inline.
       Se probo con documentElement.style.overflow='hidden': el atributo queda
       puesto pero el computado sigue en visible, o sea que una regla del tema
       con !important le gana al inline. Y el que desplaza aqui es el BODY
       (overflow computado "hidden auto"), no el html, asi que hay que fijar los
       dos. */
    'html.zph-mo-abierta,html.zph-mo-abierta body{overflow:hidden!important;}' +
    /* Escritorio: centrada. */
    '@media (min-width:768px){' +
      '.zph-mo{align-items:center;justify-content:center;padding:32px;}' +
      '.zph-mo__caja{width:100%;max-width:620px;max-height:82vh;' +
        'transform:translateY(12px) scale(.99);transition:transform .34s ' + CURVA + ';}' +
      '.zph-mo.is-on .zph-mo__caja{transform:none;}' +
    '}' +
    /* Movil: hoja inferior. Sube desde abajo, esquinas redondeadas arriba y una
       barrita de agarre, que es el gesto que el dedo ya espera. */
    '@media (max-width:767px){' +
      '.zph-mo{align-items:flex-end;}' +
      '.zph-mo__caja{width:100%;max-height:88vh;border-radius:14px 14px 0 0;padding-top:8px;' +
        'transform:translateY(100%);transition:transform .38s ' + CURVA + ';}' +
      '.zph-mo.is-on .zph-mo__caja{transform:none;}' +
      '.zph-mo__caja::before{content:"";display:block;width:38px;height:4px;border-radius:2px;' +
        'background:#d8d3cd;margin:0 auto 6px;}' +
      '.zph-mo__cab{padding:14px 20px;}' +
      '.zph-mo__t{font-size:20px;}' +
      '.zph-mo__x{width:44px;height:44px;margin:-10px -12px 0 0;}' +   /* toque de 44px */
      '.zph-mo__cuerpo{padding:18px 20px calc(28px + env(safe-area-inset-bottom));}' +
    '}';
  document.head.appendChild(css);

  /* Al bloquear el scroll del fondo se compensa el ancho de la barra para que la
   * pagina no salte de lado. */
  function anchoBarra() { return window.innerWidth - document.documentElement.clientWidth; }

  function extraer(html) {
    var d;
    try { d = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return null; }
    var src = d.querySelector('#MainContent .t4s-rte') || d.querySelector('.t4s-rte');
    if (!src || src.textContent.replace(/\s+/g, ' ').trim().length < 40) return null;

    var frag = src.cloneNode(true);
    // Nada ejecutable ni estilos ajenos dentro de la ventana.
    [].slice.call(frag.querySelectorAll('script,style,link,noscript,iframe,object,embed'))
      .forEach(function (n) { n.remove(); });

    /* El titulo es el PRIMER HIJO si es un encabezado con texto, y se busca
     * hasta h3: politica-de-envios titula con H3 (no tiene ningun h1 ni h2, y
     * buscando solo h1,h2 el titulo salia vacio y caia en "Informacion"),
     * mientras politica-de-cambios titula con H1 y lo repite dos veces.
     * Se exige que sea el PRIMER hijo para no robar un encabezado de mitad del
     * texto como titulo de la ventana. */
    var titulo = '';
    var pri = frag.firstElementChild;

    /* Antes hay que barrer los nodos vacios de arriba: politica-de-cambios
     * empieza con un <h1></h1> SIN TEXTO y despues viene el titulo de verdad.
     * Sin esto la regla del "primer hijo" veia el vacio, se rendia, y quedaban
     * el titulo generico arriba y el encabezado repetido dentro del texto. */
    while (pri && /^(H[1-6]|P|DIV|BR)$/.test(pri.tagName) &&
           !pri.textContent.replace(/\s+/g, ' ').trim() &&
           !pri.querySelector('img,svg,table')) {
      var vacio = pri;
      pri = pri.nextElementSibling;
      vacio.remove();
    }

    if (pri && /^H[1-3]$/.test(pri.tagName)) {
      var t = pri.textContent.replace(/\s+/g, ' ').trim();
      if (t) {
        titulo = t;
        var sig = pri.nextElementSibling;
        pri.remove();
        if (sig && /^H[1-3]$/.test(sig.tagName) &&
            sig.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === titulo.toLowerCase()) {
          sig.remove();
        }
      }
    }
    return { titulo: titulo, html: frag.innerHTML };
  }

  function cerrar() {
    if (!caja) return;
    var c = caja;
    caja = null;
    c.classList.remove('is-on');
    document.removeEventListener('keydown', teclas, true);
    clearTimeout(cerrando);
    cerrando = setTimeout(function () {
      c.remove();
      document.documentElement.classList.remove('zph-mo-abierta');
      document.body.style.paddingRight = '';
      if (foco && foco.focus) { try { foco.focus(); } catch (e) {} }
      foco = null;
    }, 300);
  }

  function teclas(ev) {
    if (!caja) return;
    if (ev.key === 'Escape') { ev.preventDefault(); cerrar(); return; }
    if (ev.key !== 'Tab') return;
    // Trampa de foco simple: el tabulador no se escapa de la ventana.
    var f = caja.querySelectorAll('button,a[href],[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var pri = f[0], ult = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === pri) { ev.preventDefault(); ult.focus(); }
    else if (!ev.shiftKey && document.activeElement === ult) { ev.preventDefault(); pri.focus(); }
  }

  function pintar(dato) {
    if (caja) cerrar();
    foco = document.activeElement;

    var m = document.createElement('div');
    m.className = 'zph-mo';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', dato.titulo || 'Información');
    m.innerHTML =
      '<div class="zph-mo__fondo" data-zph-cerrar></div>' +
      '<div class="zph-mo__caja">' +
        '<div class="zph-mo__cab">' +
          '<h2 class="zph-mo__t"></h2>' +
          '<button type="button" class="zph-mo__x" data-zph-cerrar aria-label="Cerrar">' +
            '<svg viewBox="0 0 16 14" aria-hidden="true"><path d="M15 0L1 14m14 0L1 0" ' +
            'stroke="currentColor" fill="none" fill-rule="evenodd"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="zph-mo__cuerpo"></div>' +
      '</div>';
    m.querySelector('.zph-mo__t').textContent = dato.titulo || 'Información';
    m.querySelector('.zph-mo__cuerpo').innerHTML = dato.html;

    m.addEventListener('click', function (ev) {
      if (ev.target.closest && ev.target.closest('[data-zph-cerrar]')) { ev.preventDefault(); cerrar(); }
    });

    var barra = anchoBarra();
    document.body.appendChild(m);
    document.documentElement.classList.add('zph-mo-abierta');
    if (barra > 0) document.body.style.paddingRight = barra + 'px';
    caja = m;
    document.addEventListener('keydown', teclas, true);

    // Un frame antes de encender, si no la transicion no se ve.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        m.classList.add('is-on');
        var x = m.querySelector('.zph-mo__x');
        if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
        /* La ventana abria con el texto ya desplazado 106px (medido): algo mueve
         * el contenedor durante la entrada, aun pidiendo preventScroll al dar
         * el foco. Se fuerza el arranque arriba en vez de perseguir la causa. */
        var cu = m.querySelector('.zph-mo__cuerpo');
        if (cu) cu.scrollTop = 0;
      });
    });
  }

  function abrir(a) {
    var url = a.getAttribute('href');
    if (CACHE[url]) { pintar(CACHE[url]); return; }

    var t = setTimeout(function () { a.classList.add('zph-cargando'); }, 200);
    function fin() { clearTimeout(t); a.classList.remove('zph-cargando'); }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        fin();
        var d = extraer(html);
        if (!d) { window.location.href = url; return; }   // no es pagina de texto
        CACHE[url] = d;
        pintar(d);
      })
      .catch(function () { fin(); window.location.href = url; });
  }

  document.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;
    if (ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;  // pestana nueva
    var a = ev.target.closest('a[href^="/pages/"]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('data-zph-nomodal')) return;
    if (!a.closest('.t4s-product__info-container')) return;
    ev.preventDefault();
    abrir(a);
  });
})();
